var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button button-close",on:{"click":function($event){return _vm.$emit('close')}}},[_vm._t("default"),_c('fas-icon',{staticClass:"icon-right",attrs:{"icon":"times"}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }